import { Data2, dateToString, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useSystemStateHooks } from '../../system'
import { DeliveryItemDeliveryStats, DeliveryMethod, DeliveryOrder, DeliveryOrderItem, DeliveryStatus, NotDeliveredItem } from '../state/types'

export const useDeliveryOrderBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildDeliveryItemDeliveryStats = (data: Data2) => {
        const { toBeDelivered, pending, dispatched, delivered, cancelled, returned } = data
        const deliveryItemDeliveryStats: DeliveryItemDeliveryStats = {
            toBeDelivered: toBeDelivered! as number,
            pending: pending! as number,
            dispatched: dispatched! as number,
            delivered: delivered! as number,
            cancelled: (cancelled || 0) as number,
            returned: (returned || 0) as number
        }

        return deliveryItemDeliveryStats
    }

    const buildDeliveryOrderItem = (data: Data2) => {
        const { itemId, quantity, deliveryStats } = data
        const deliveryOrderItem: DeliveryOrderItem = {
            itemId: itemId! as string,
            quantity: quantity! as number,
            deliveryStats: (deliveryStats || buildDeliveryItemDeliveryStats({
                toBeDelivered: quantity,
                pending: quantity,
                dispatched: 0,
                delivered: 0
            })) as DeliveryItemDeliveryStats
        }
        
        return deliveryOrderItem
    }

    const buildDeliveryOrder = (data: Data2) => {
        const {
            id = newId(),
            code,
            table,
            operationId,
            method,
            items,
            creationDate,
            deliveryDate,
            supplierId,
            customerId,
            branchId,
            addressId,
            deliveryStatus,
            notDeliveredCount,
            cancelled
        } = data
        const deliveryOrder: DeliveryOrder = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            codeStr: code!.toString()!,            
            table: table! as TableName,
            operationId: operationId! as string,
            method: method! as DeliveryMethod,
            items: (items || []) as DeliveryOrderItem[],
            creationDate: dateToString(creationDate || new Date())!,
            deliveryDate: dateToString(deliveryDate || new Date())!,
            supplierId: supplierId as O<string>,
            customerId: customerId as O<string>,
            branchId: branchId! as string,
            addressId: addressId! as string,
            deliveryStatus: (deliveryStatus || DeliveryStatus.PENDING) as DeliveryStatus,
            notDeliveredCount: (notDeliveredCount || []) as NotDeliveredItem[],
            cancelled: cancelled as O<boolean>
        }

        return deliveryOrder
    }

    return {
        buildDeliveryItemDeliveryStats,
        buildDeliveryOrderItem,
        buildDeliveryOrder
    }
}
